import { render, staticRenderFns } from "./Crisis_document.vue?vue&type=template&id=6c4df321"
import script from "./Crisis_document.vue?vue&type=script&lang=js"
export * from "./Crisis_document.vue?vue&type=script&lang=js"
import style0 from "./Crisis_document.vue?vue&type=style&index=0&id=6c4df321&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports